<template>
  <div class="pa-2 pt-8">
    <div class="d-flex align-center mb-4">
      <div class="body-2 mr-2">{{ index + 1 }}</div>

      <v-text-field
        dark
        dense
        hide-details
        outlined
        placeholder="Question Text"
        color="primary"
        class="flex-grow-0 mr-4"
        :value="question.question"
        @input="$emit('questionInput', question.id, $event)"
      >
      </v-text-field>

      <v-btn
        small
        outlined
        color="primary"
        class="mr-4"
        @click="$emit('addAnswer', question.id)"
        >add answer</v-btn
      >

      <v-btn small color="error" @click="$emit('deleteQuestion', question.id)"
        >delete</v-btn
      >
    </div>

    <div class="pl-8">
      <div
        class="d-flex align-center mb-2"
        v-for="(answer, index) in question.answers"
        :key="answer.id"
      >
        <div class="body-2 mr-2">{{ index + 1 }}</div>

        <v-text-field
          dark
          dense
          hide-details
          outlined
          placeholder="Answer Text"
          color="primary"
          class="flex-grow-0 mr-4"
          :value="answer.answer"
          @input="$emit('answerInput', question.id, answer.id, $event)"
        >
        </v-text-field>

        <v-checkbox
          :value="true"
          @change="$emit('correctAnswer', question.id, answer.id, $event)"
          :input-value="answer.isCorrect"
          dense
          hide-details
          class="pa-0 ma-0 mr-2"
          dark
          :ripple="false"
          color="primary"
        ></v-checkbox>

        <v-btn
          small
          color="error"
          @click="$emit('deleteAnswer', question.id, answer.id)"
          >delete</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["question", "index"],
};
</script>

<style lang="scss" scoped>
</style>